    // ------------------------------------------------------------
    // Announcement bar — measure height for sticky nav offset,
    // dismiss button collapses bar and snaps nav to top
    // ------------------------------------------------------------
    (function () {
      const bar = document.getElementById("announce");
      const close = document.getElementById("announceClose");
      const root = document.documentElement;

      // Keep the nav's sticky offset in sync with the bar's actual height
      function syncAnnounceHeight() {
        if (!bar || !bar.isConnected) {
          root.style.setProperty("--announce-h", "0px");
          return;
        }
        root.style.setProperty("--announce-h", bar.offsetHeight + "px");
      }

      syncAnnounceHeight();
      window.addEventListener("resize", syncAnnounceHeight);

      if (!bar || !close) return;

      close.addEventListener("click", function () {
        // Snap the nav up to top: 0 immediately — its CSS transition
        // smooths the move while the bar collapses in parallel.
        root.style.setProperty("--announce-h", "0px");

        bar.style.transition =
          "opacity 0.22s ease, max-height 0.28s ease, padding 0.28s ease";
        bar.style.overflow = "hidden";
        bar.style.maxHeight = bar.offsetHeight + "px";

        requestAnimationFrame(function () {
          bar.style.opacity = "0";
          bar.style.maxHeight = "0";
          bar.style.paddingTop = "0";
          bar.style.paddingBottom = "0";
        });

        setTimeout(function () {
          bar.remove();
        }, 300);
      });
    })();

    // ------------------------------------------------------------
    // FAQ accordion (multi-open allowed, supports multiple lists)
    // Used by home page (1 list) and product page (2 lists side-by-side).
    // ------------------------------------------------------------
    (function () {
      const lists = document.querySelectorAll(".faq__list");
      if (!lists.length) return;

      function setupList(list) {
        // Set initial heights for items that start open
        list.querySelectorAll(".faq-item.is-open").forEach(function (item) {
          const panel = item.querySelector(".faq-item__panel");
          if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
        });

        // Click handler
        list.addEventListener("click", function (e) {
          const btn = e.target.closest(".faq-item__btn");
          if (!btn) return;

          const item = btn.closest(".faq-item");
          const panel = item.querySelector(".faq-item__panel");
          const opening = !item.classList.contains("is-open");

          item.classList.toggle("is-open");
          btn.setAttribute("aria-expanded", opening ? "true" : "false");
          panel.style.maxHeight = opening ? panel.scrollHeight + "px" : "0";
        });
      }

      lists.forEach(setupList);

      // Recalculate open panel heights on resize (text reflow)
      let resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          document.querySelectorAll(".faq-item.is-open .faq-item__panel").forEach(function (panel) {
            panel.style.maxHeight = panel.scrollHeight + "px";
          });
        }, 120);
      });
    })();

    // ------------------------------------------------------------
    // VIP signup (placeholder handler)
    // ------------------------------------------------------------
    (function () {
      const form = document.getElementById("vipForm");
      if (!form) return;

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        const input = form.querySelector("input[type='email']");
        const btn = form.querySelector("button");
        if (!input.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
          input.focus();
          return;
        }
        const original = btn.textContent;
        btn.textContent = "✓ You're In";
        btn.disabled = true;
        input.value = "";
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 2400);
      });
    })();


    // ============================================================
    // ============================================================
    //
    //  PRODUCT PAGE  —  scripts for product.html
    //  (each IIFE early-returns if its target isn't on the page)
    //
    // ============================================================
    // ============================================================

    // ------------------------------------------------------------
    // Product page — gallery thumbnail swap
    // ------------------------------------------------------------
    (function () {
      const main = document.getElementById("galleryMain");
      const thumbs = document.getElementById("galleryThumbs");
      if (!main || !thumbs) return;

      thumbs.addEventListener("click", function (e) {
        const thumb = e.target.closest(".gallery__thumb");
        if (!thumb) return;
        const newImg = thumb.dataset.img || thumb.style.backgroundImage;
        if (!newImg) return;

        // Swap active state
        thumbs.querySelectorAll(".gallery__thumb.is-active").forEach(function (t) {
          t.classList.remove("is-active");
        });
        thumb.classList.add("is-active");

        // Swap main image
        if (thumb.dataset.img) {
          main.style.backgroundImage = "url('" + thumb.dataset.img + "')";
        } else {
          main.style.backgroundImage = thumb.style.backgroundImage;
        }
      });
    })();

    // ------------------------------------------------------------
    // Product page — battery option radios
    // ------------------------------------------------------------
    (function () {
      const list = document.getElementById("batteryOptions");
      if (!list) return;

      function syncSelected() {
        list.querySelectorAll(".battery-option").forEach(function (opt) {
          const input = opt.querySelector("input[type='radio']");
          opt.classList.toggle("is-selected", !!(input && input.checked));
        });
      }

      list.addEventListener("change", function (e) {
        if (e.target.type === "radio") syncSelected();
      });

      syncSelected();
    })();


    // ------------------------------------------------------------
    // Dealer logo strip — auto-scrolling marquee with drag-to-scrub
    // Runs on any page that has a .dealer__logos container.
    // Wraps direct .dealer__logo children in a track, duplicates
    // them for seamless looping, animates leftward at a slow pace,
    // and lets users grab + drag in either direction.
    // ------------------------------------------------------------
    (function () {
      const containers = document.querySelectorAll(".dealer__logos");
      if (!containers.length) return;

      containers.forEach(initStrip);

      function initStrip(logosEl) {
        // Collect the existing logo children
        const logos = Array.from(logosEl.children).filter(function (el) {
          return el.classList && el.classList.contains("dealer__logo");
        });
        if (!logos.length) return;

        // Build the sliding track
        const track = document.createElement("div");
        track.className = "dealer__track";
        logos.forEach(function (logo) {
          track.appendChild(logo);
        });
        logosEl.appendChild(track);

        // Duplicate logos once for seamless wrap; if the duplicated
        // track is still narrower than 2x viewport, duplicate again.
        function ensureWidth() {
          while (track.scrollWidth < logosEl.offsetWidth * 2) {
            logos.forEach(function (logo) {
              track.appendChild(logo.cloneNode(true));
            });
          }
        }
        // First duplicate pass
        logos.forEach(function (logo) {
          track.appendChild(logo.cloneNode(true));
        });
        ensureWidth();

        // ------- Animation state -------
        let position = 0;
        const SPEED = -0.5; // pixels per frame (leftward)
        let halfWidth = track.scrollWidth / 2;

        // Recalculate on resize so wrap stays seamless after layout shifts
        let resizeTimer;
        window.addEventListener("resize", function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            ensureWidth();
            // halfWidth depends on number of duplicates; recompute as
            // half the total track width since we always have an even
            // number of duplicate passes.
            halfWidth = track.scrollWidth / 2;
            // Wrap current position into the new range
            while (position <= -halfWidth) position += halfWidth;
            while (position > 0) position -= halfWidth;
          }, 120);
        });

        // ------- Drag state -------
        let isDragging = false;
        let dragStartX = 0;
        let dragStartPosition = 0;
        let pointerId = null;

        logosEl.addEventListener("pointerdown", function (e) {
          isDragging = true;
          dragStartX = e.clientX;
          dragStartPosition = position;
          pointerId = e.pointerId;
          logosEl.classList.add("is-dragging");
          // Capture the pointer so move events keep firing even if the
          // cursor leaves the strip during a drag
          try {
            logosEl.setPointerCapture(e.pointerId);
          } catch (_) { /* not all environments support capture */ }
          e.preventDefault();
        });

        logosEl.addEventListener("pointermove", function (e) {
          if (!isDragging) return;
          const dx = e.clientX - dragStartX;
          position = dragStartPosition + dx;
        });

        function endDrag(e) {
          if (!isDragging) return;
          isDragging = false;
          logosEl.classList.remove("is-dragging");
          if (pointerId !== null) {
            try {
              logosEl.releasePointerCapture(pointerId);
            } catch (_) { /* ignore */ }
            pointerId = null;
          }
        }

        logosEl.addEventListener("pointerup", endDrag);
        logosEl.addEventListener("pointercancel", endDrag);

        // ------- Animation loop -------
        function tick() {
          if (!isDragging) {
            position += SPEED;
          }
          // Wrap into [-halfWidth, 0] for infinite scroll
          while (position <= -halfWidth) position += halfWidth;
          while (position > 0) position -= halfWidth;
          track.style.transform = "translateX(" + position + "px)";
          requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }
    })();
